<template>
    <div>
        <template v-if="data.subStatusDeliveryState != null">
            <span ref="trigger" :style="subStatusStyle"> {{ data.subStatusDeliveryStateText }}</span>
            <b-popover :target="popoverTarget" triggers="hover">
                <div v-if="data.audioSubStatusDisplayName != null">Audio Status: {{ data.audioSubStatusDisplayName }}</div>
                <div v-if="data.logNotesSubStatusDisplayName != null"> Log Status: {{ data.logNotesSubStatusDisplayName }}</div>
                <div v-if="data.releaseApprovalSubStatusDeliveryState != null">Approval Status: {{ data.releaseApprovalSubStatusDeliveryState }}</div>
                <div v-if="data.depositSubStatusDisplayName != null">Deposit Status: {{ data.depositSubStatusDisplayName }}</div>
                <div v-if="data.vettingSubStatusDisplayName != null">Vetting Status: {{ data.vettingSubStatusDisplayName }}</div>
            </b-popover>
        </template>
    </div>
</template>

<script>

    //import Vue from 'vue';
    //import axios from 'axios';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';

    
    export default {
        name: 'OrderSubStatusColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                subStatusDeliveryStateText: null,                
            };
        },
        computed: {
            subStatusStyle: function () {
                if (this.data.subStatusDeliveryState == true) return "color:green;";
                if (this.data.subStatusDeliveryState == false) return "color:red;";
                return null;
            },
        },
        methods: {
            popoverTarget: function () {
                return this.$refs.trigger;
            }
        }
    }
</script>